import {
  slab, goal, sign, checkpoint, edgeLights, gravfield, ring,
} from '../kit.js';

/**
 * Intro sector: the aurora field. Gravity is gentle inside the light, so a
 * plain jump becomes a glide. The second crossing hangs a familiar boost
 * ring in the field: one new idea, one known one, stacked.
 */
export default {
  id: 'aurora',
  name: 'AURORA',
  blurb: 'Gravity is gentle in the light. Jump.',
  mode: { type: 'sprint', par: 26 },
  redline: { seconds: 20 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 8], yaw: 0 },
  killY: -40,
  env: {
    fog: 0x120a24,
    fogDensity: 0.0040,
    sky: { zenith: 0x070312, horizon: 0x1c0f38, glow: 0x7a3ad8, aurora: 0xb28aff },
    floorY: -160,
  },
  objects: [
    // ---- start deck
    slab(0, 0, 0, 24, 24, 'plate', 1.4),
    ...edgeLights(0, 0, 0, 24, 24, 'cyan'),
    checkpoint(0, 0, 6),
    sign(0, 3.2, 5, 0, ['AURORA', 'GRAVITY IS GENTLE IN THE LIGHT', 'JUMP. FLOAT. STEER.'], '#b28aff'),

    // ---- crossing one: a 16m chasm bathed in aurora. Traced: drift while
    // floating is walk speed and the glide descends at 0.28g, which crosses
    // 17m from a hop before it sinks to deck level. The field buys TIME,
    // not distance; the gap has to respect that.
    gravfield(0, -10, -20, 24, 26, 22),
    slab(0, 0, -40, 24, 24, 'plate', 1.4),
    ...edgeLights(0, 0, -40, 24, 24, 'cyan'),
    checkpoint(0, 0, -36),
    sign(0, 3.2, -37, 0, ['A RING WAITS IN THE LIGHT'], '#ffb020'),

    // ---- crossing two: four times as wide, because the ring early in the
    // float throws you up and onward; the arc clears the field's far edge
    // at height and parachutes onto the goal deck
    // The field begins AT the deck edge: a hop must enter the light while
    // still rising. A field that starts mid-chasm receives bodies already
    // falling at full speed, and gentle gravity cannot un-fall them.
    gravfield(0, -10, -74, 24, 26, 44),
    // Two rings stacked into one catch band: a hop can leave the edge
    // rising or sinking, and either entry height must find a throw.
    ring(0, 1.2, -63, [0, 0.6, -0.8], 15, 2.8),
    ring(0, 5.6, -65, [0, 0.6, -0.8], 15, 2.8),
    slab(0, 0, -122, 26, 26, 'plate', 1.6),
    ...edgeLights(0, 0, -122, 26, 26, 'lime'),
    checkpoint(0, 0, -116),
    goal(0, 0, -128, 0),
  ],
};
